import { Validation } from './validation';
import { deleteComma } from '../../utilities/delete-comma';
import { deleteHyphen } from '../../utilities/delete-str';

export const ValidationMax10Billion: Validation[] = [
  new Validation(
    (v) => Number(deleteComma(deleteHyphen(v))) <= 9999999999,
    `${9999999999}以下で入力してください。`,
  ),
];
